// src/components/profile/DocumentTypeSelector.jsx

import React from 'react';

import {
  ChevronDownIcon,
} from '../common/IconsComponent';

const DocumentTypeSelector = ({
  selectedDocType,
  setSelectedDocType,
  documentTypes,
  error,
}) => {

  return (
    <div dir="rtl">

      <label className="block text-sm font-medium text-gray-700 mb-1.5">
        סוג מסמך
      </label>

      <div className="relative">

        <select
          value={selectedDocType}

          onChange={(e) =>
            setSelectedDocType(
              e.target.value
            )
          }

          className={`
            w-full
            bg-white
            border
            rounded-xl
            px-3
            py-2.5
            pr-4
            pl-9
            text-sm
            appearance-none
            cursor-pointer
            transition-colors

            focus:outline-none
            focus:ring-2
            focus:ring-indigo-300
            focus:border-indigo-400

            ${
              error
                ? `
                  border-red-400
                  focus:ring-red-200
                  focus:border-red-400
                `
                : `
                  border-gray-200
                  hover:border-gray-300
                  text-gray-700
                `
            }

            ${
              !selectedDocType
                ? 'text-gray-400'
                : 'text-gray-800'
            }
          `}
        >

          <option
            value=""
            disabled
          >
            בחר סוג מסמך
          </option>

          {(documentTypes ?? []).map(
            (type) => (
              <option
                key={type}
                value={type}
              >
                {type}
              </option>
            )
          )}

        </select>

        <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-gray-400">

          <ChevronDownIcon
            size={15}
          />

        </div>

      </div>

      {error && (
        <p className="text-red-500 text-xs mt-1.5">
          {error}
        </p>
      )}

    </div>
  );
};

export default DocumentTypeSelector;